import React from 'react'
import { Outlet } from 'react-router-dom'
import { AppLayout as SharedAppLayout } from '@scryerlabs/ui'
import AppSidebar from './AppSidebar'
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'

/**
 * Sidebar and header state now lives in the package. Both apps held the same pair of
 * useState hooks and threaded them down by hand - the repeated decision worth removing,
 * and the reason the shell takes render props rather than plain slots.
 */
const AppLayout: React.FC = () => (
  <SharedAppLayout
    sidebar={({ sidebarVisible, setSidebarVisible, unfoldable, setUnfoldable }) => (
      <AppSidebar
        visible={sidebarVisible}
        onVisibleChange={setSidebarVisible}
        unfoldable={unfoldable}
        onUnfoldableChange={setUnfoldable}
      />
    )}
    header={({ toggleSidebar }) => <AppHeader onToggleSidebar={toggleSidebar} />}
    footer={<AppFooter />}
  >
    <Outlet />
  </SharedAppLayout>
)

export default AppLayout
